import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { QuotationDetailsComponent } from './quotation-details.component';
import { PageNotFoundComponent } from '@app/pages/page-not-found/page-not-found.component';

const routes: Routes = [

    {
        path: ':slug',
        component: QuotationDetailsComponent,
        //outlet:
    },
    {
        path: '**',
        component: PageNotFoundComponent,
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class QuotationRoutingModule { }
